import styled from '@emotion/styled';
import { Skeleton as MUISkeleton } from '@mui/material';

import { COLORS } from '../../variables';
import type { SkeletonProps } from './index';

export const Skeleton = styled(MUISkeleton)`
  ${(props: SkeletonProps) => `
    background-color: ${
      props.color ? COLORS[props.color.replace('-', '_').toUpperCase() as keyof typeof COLORS] : COLORS.SECONDARY_300
    };
  `};
`;
